import {
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_BEGIN,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_SUCCESS,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_FAILURE,
  DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function loadExternalDatabaseForSalesforce(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_BEGIN,
    });
    const { projectId, version, externalDbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/salesforce/${externalDbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadExternalDatabaseForSalesforceError() {
  return {
    type: DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_BEGIN:
      return {
        ...state,
        loadExternalDatabaseForSalesforcePending: true,
        loadExternalDatabaseForSalesforceError: null,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_SUCCESS:
      return {
        ...state,
        loadExternalDatabaseForSalesforcePending: false,
        loadExternalDatabaseForSalesforceError: null,
        externalDbSalesforce: action.data,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_FAILURE:
      return {
        ...state,
        loadExternalDatabaseForSalesforcePending: false,
        loadExternalDatabaseForSalesforceError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_EXTERNAL_DATABASE_FOR_SALESFORCE_DISMISS_ERROR:
      return {
        ...state,
        loadExternalDatabaseForSalesforceError: null,
      };

    default:
      return state;
  }
}
